import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/next-frontend/src/components/pages/home/courseDetails/components/CourseDetailSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/next-frontend/src/components/pages/home/courseDetails/components/CourseHeroSection.js");
